const TAMANHO_MAXIMO_PADRAO_CARTEIRINHA = 30

// Subconjunto dos tokens do vue-the-mask aceito na máscara do convênio. Qualquer outro caractere é separador.
const PADRAO_POR_TOKEN: { [token: string]: RegExp | undefined } = {
  '#': /\d/,
  X: /[0-9a-zA-Z]/,
}

// Letra ou dígito como separador se confundiria com o valor digitado; '!' é o caractere de escape do vue-the-mask.
const CARACTERE_PROIBIDO_COMO_SEPARADOR = /[A-Za-z0-9!]/

const isTokenDaMascara = (caractere: string): boolean => !!PADRAO_POR_TOKEN[caractere]

const isMascaraCarteirinhaValida = (mascara: string): boolean => {
  const caracteres = mascara.split('')
  const separadores = caracteres.filter(caractere => !isTokenDaMascara(caractere))

  return caracteres.some(isTokenDaMascara) && !separadores.some(separador => CARACTERE_PROIBIDO_COMO_SEPARADOR.test(separador))
}

// Quantos caracteres a pessoa digita: só os tokens, sem os separadores.
const contarPosicoesDaMascara = (mascara: string): number => mascara.split('').filter(isTokenDaMascara).length

// Separador é só de exibição: a carteirinha é gravada só com letras e dígitos (mesma limpeza do RemoveSpecialCharacter do backend).
const removerSeparadoresCarteirinha = (valor: string): string => valor.replace(/[^0-9a-zA-Z]/g, '')

// Mesmo algoritmo do maskit do vue-the-mask (para os tokens # e X), para o valor exibido bater com o que a diretiva formata.
const formatarCarteirinha = (valor: string, mascara: string): string => {
  let formatado = ''
  let posicaoMascara = 0
  let posicaoValor = 0

  while (posicaoMascara < mascara.length && posicaoValor < valor.length) {
    const caractereMascara = mascara[posicaoMascara]
    const caractereValor = valor[posicaoValor]
    const padrao = PADRAO_POR_TOKEN[caractereMascara]

    if (padrao) {
      if (padrao.test(caractereValor)) {
        formatado += caractereValor
        posicaoMascara += 1
      }

      posicaoValor += 1
    } else {
      formatado += caractereMascara

      if (caractereValor === caractereMascara) {
        posicaoValor += 1
      }

      posicaoMascara += 1
    }
  }

  const restoDaMascara = mascara.slice(posicaoMascara)

  if (restoDaMascara.split('').some(isTokenDaMascara)) {
    return formatado
  }

  return formatado + restoDaMascara
}

const normalizarCarteirinha = (valor: string, mascara: string): string => removerSeparadoresCarteirinha(formatarCarteirinha(valor, mascara))

// É o maxlength do input, que vale sobre o valor exibido: com máscara, conta os separadores.
const getTamanhoMaximoCarteirinha = (mascara: string | undefined, tamanhoMaximoDoTemplate?: number | string): number => {
  if (mascara) {
    return mascara.length
  }

  return Number(tamanhoMaximoDoTemplate) || TAMANHO_MAXIMO_PADRAO_CARTEIRINHA
}

// Obrigatoriedade continua com a regra de cada tela; aqui só se exige o preenchimento completo da máscara.
// A contagem ignora os separadores, igual ao contador do campo.
const validateCarteirinhaComMascara = (carteirinha: string | null | undefined, mascara: string): true | string => {
  if (!mascara || !carteirinha) {
    return true
  }

  const posicoes = contarPosicoesDaMascara(mascara)

  if (normalizarCarteirinha(carteirinha, mascara).length === posicoes) {
    return true
  }

  return `A carteirinha deste convênio deve ter ${posicoes} caracteres.`
}

export {
  isMascaraCarteirinhaValida,
  contarPosicoesDaMascara,
  removerSeparadoresCarteirinha,
  formatarCarteirinha,
  normalizarCarteirinha,
  getTamanhoMaximoCarteirinha,
  validateCarteirinhaComMascara,
}
